import Layout from '@ep/components/Layout';
import SEO from '@ep/components/Seo';
import HeroCTAModule, { HeroCTAModuleProps } from '@ep/modules/HeroCTAModule';
import HeroIconModule from '@ep/modules/HeroIconModule';
import VersionedDocumentModule from '@ep/modules/VersionedDocumentModule';
import theme from '@ep/theme';
import { Gcms_LegalPolicyPage } from '@ep/types/gatsbyTypes';
import getModuleProps from '@ep/utils/getModuleProps';
import getSeoProps from '@ep/utils/getSeoProps';
import { WindowLocation } from '@reach/router';
import { graphql } from 'gatsby';
import React from 'react';

export interface LegalPolicyPageProps {
  location: WindowLocation;
  data: {
    gcms: {
      page: Gcms_LegalPolicyPage;
    };
  };
}

function LegalPolicyPage({ location, data }: LegalPolicyPageProps) {
  const page = data.gcms.legalPolicyPage;

  return (
    <Layout pathname={location.pathname}>
      <SEO {...getSeoProps(page)} />
      <HeroIconModule
        heading={page.title}
        backgroundColor={theme.colors.bannerBlue}
      />
      <VersionedDocumentModule page={page} />
    </Layout>
  );
}

export const query = graphql`
  query LegalPolicyPageQuery($id: ID!) {
    gcms {
      legalPolicyPage(where: { id: $id }) {
        title
        metaTitle
        description
        metaDescription
        structuredData
        slug
        pdfLogo
        featuredImage {
          url
          altText
          vidyardLink
        }
        heading
        sidebar {
          html
        }
        legalDocument(orderBy: uploadDate_DESC) {
          id
          title
          uploadDate
          sectionNames
          body {
            html
          }
        }
      }
    }
  }
`;

export default LegalPolicyPage;
